import { fetchData, postData, putData } from "../utils/apiUtils";
import useGetUserToken from "../utils/getUserToken";
function useFinanceApi() {
  const token = useGetUserToken();

  const get_expense = async () => {
    const url = "finance/expense";
    const expenseData = await fetchData(url, token);
    return expenseData;
  };
  const get_expenseByDate = async (date) => {
    const url = `finance/expense/bydate?date=${encodeURIComponent(date)}`;
    const expenseData = await fetchData(url, token);
    return expenseData;
  };
  const addExpense = async (newExpense) => {
    const url = `finance/expense/register`;
    const responseData = await postData(url, newExpense, token);
    return responseData;
  };

  const get_expense_catagory = async () => {
    const url = "finance/expense-catagory";
    const expenseCatagoryData = await fetchData(url, token);
    return expenseCatagoryData;
  };

  const addExpenseCatagory = async (newExpense) => {
    const url = `finance/expense-catagory/register`;
    const responseData = await postData(url, newExpense, token);
    return responseData;
  };

  const updateExpenseCatagory = async (newMethod) => {
    const url = `finance/expense-catagory/update`;
    const responseData = await putData(url, newMethod, token);
    return responseData;
  };
  const get_payment_method = async () => {
    const url = "finance/payment-method";
    const expenseCatagoryData = await fetchData(url, token);
    return expenseCatagoryData;
  };

  const addPaymentMethod = async (newMethod) => {
    const url = `finance/payment-method/register`;
    const responseData = await postData(url, newMethod, token);
    return responseData;
  };
  const updatePaymentMethod = async (newMethod) => {
    const url = `finance/payment-method/update`;
    const responseData = await putData(url, newMethod, token);
    return responseData;
  };
  return {
    get_expense,
    get_expenseByDate,
    get_expense_catagory,
    addExpense,
    addExpenseCatagory,
    updateExpenseCatagory,
    get_payment_method,
    addPaymentMethod,
    updatePaymentMethod,
  };
}
export default useFinanceApi;
